import { useEffect } from 'react'
import './Redirect.scss'

const Redirect = ( props ) => {
   const { url } = props
   useEffect(() => {
      window.location.href = url;
   }, [url]);

   return <p className="Redirect">DID YOU KNOW!? here comes a fun fact! get a load of this!!! basically: ur not supposed to have enough time to read this! however, also, in lieu of that information, another important lengthy point to make is: hi aestus</p>
}

export default Redirect